import { useMutation, useQuery } from "@tanstack/react-query"
import DimensionsToleranceService from "services/dimensionsTolerance.service"
import type { TDimensionsToleranceValues } from "types/configuration.type"

export const useDimensionsTolerance = () => {
	return useQuery({
		queryKey: ["dimensionsTolerance"],
		queryFn: () => DimensionsToleranceService.getTolerance(),
		select: ({ data }) => data,
	})
}

export const useUpdateDimensionsTolerance = () => {
	return useMutation({
		mutationKey: ["updateDimensionsTolerance"],
		mutationFn: (values: TDimensionsToleranceValues) => DimensionsToleranceService.updateTolerance(values),
	})
}
